import apiClient from './api';

const accessService = {
  getMine: async () => (await apiClient.get('/permissions/access/me/')).data,
  getCatalog: async () => (await apiClient.get('/permissions/access/catalog/')).data,
  setPageActive: async (path, isActive) =>
    (await apiClient.patch('/permissions/access/pages/', { path, is_active: isActive })).data,
  getGroup: async (groupId) => (await apiClient.get(`/permissions/access/groups/${groupId}/`)).data,
  saveGroup: async (groupId, changes) =>
    (await apiClient.put(`/permissions/access/groups/${groupId}/`, { changes })).data,
  previewGroup: async (groupId) => (await apiClient.get(`/permissions/access/groups/${groupId}/preview/`)).data,
  searchUsers: async (search = '') =>
    (await apiClient.get('/permissions/access/users/', { params: search ? { search } : {} })).data,
  getEffective: async (userId) => (await apiClient.get(`/permissions/access/users/${userId}/effective/`)).data,
  getHistory: async (groupId) =>
    (await apiClient.get('/permissions/access/history/', { params: groupId ? { group: groupId } : {} })).data,
  undo: async (logId) => (await apiClient.post(`/permissions/access/history/${logId}/undo/`)).data,
};

export default accessService;
